// 获取七牛上传图片 token
// eslint-disable-next-line import/prefer-default-export
export const GET_QINIU_IMAGE_UPLOAD_TOKEN = '03500242';

export const COMMIT_INSURANCE = '66646101'; // 保险投保接口
export const GET_INSURANCE_INFO = '66646102'; // 查询保险投保详情
export const COMMIT_CLAIM = '66646103'; // 提交索赔
export const COMMIT_CLAIM_LIST = '66646104'; // 提交索赔列表
export const GET_INSURANCE_QUERY_INFO = '66646105'; // 查询投保信息详情


// WEBPACK FOOTER //
// ./src/services/common/pids.js